module.exports = function getResource(label, vars = []) {
    let resources = {
        pausePlayAnimationLabel: `${vars[0] ? 'Interrompre': 'la lecture'} de l'animation`,
        previous: 'Précédent',
        next: 'Suivant'
    };

    return resources[label];
};
